import { api } from './api';

// Use NODE_ENV to detect non-production (development) builds.
// Vite / build tools typically replace `process.env.NODE_ENV` at build time.
const isDev = (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production')
  || (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'));

// TODO: Remove or gate mock fallbacks before production deploy.
export const communityService = {
  getCategories: async () => {
    try {
      if (isDev) {
        // Return mock data immediately when developing locally
        return [
          {
            id: 1,
            name: 'Allergi',
            description: 'Diskuter allergi, symptomer og lindringsstrategier',
            postCount: 234,
            memberCount: 1247,
            color: '#7c898b',
            icon: 'Wind'
          },
          {
            id: 2,
            name: 'Astma',
            description: 'Del erfaringer om astma, inhalatorer og daglig håndtering',
            postCount: 189,
            memberCount: 892,
            color: '#2e3b47',
            icon: 'Activity'
          },
          {
            id: 3,
            name: 'Fødevareallergi',
            description: 'Opskrifter, tips og støtte til dem med fødevareallergi',
            postCount: 156,
            memberCount: 673,
            color: '#d4183d',
            icon: 'UtensilsCrossed'
          },
          {
            id: 4,
            name: 'Eksem',
            description: 'Rådgivning om eksem, hudpleje og lindring',
            postCount: 98,
            memberCount: 445,
            color: '#4ade80',
            icon: 'Home'
          },
          {
            id: 5,
            name: 'Medicin & Behandling',
            description: 'Diskuter medicin, bivirkninger og behandlingsmetoder',
            postCount: 312,
            memberCount: 1567,
            color: '#7c898b',
            icon: 'Pill'
          },
          {
            id: 6,
            name: 'Børn & Familier',
            description: 'Særlig støtte til forældre med allergiske børn',
            postCount: 145,
            memberCount: 789,
            color: '#2e3b47',
            icon: 'Users'
          }
        ];
      }
      return await api.get('/api/community/categories');
    } catch (error) {
      console.error('Error fetching categories:', error);
      // Fallback mock data
      return [
        {
          id: 1,
          name: 'Allergi',
          description: 'Diskuter allergi, symptomer og lindringsstrategier',
          postCount: 234,
          memberCount: 1247,
          color: '#7c898b',
          icon: 'Wind'
        },
        {
          id: 2,
          name: 'Astma',
          description: 'Del erfaringer om astma, inhalatorer og daglig håndtering',
          postCount: 189,
          memberCount: 892,
          color: '#2e3b47',
          icon: 'Activity'
        },
        {
          id: 3,
          name: 'Fødevareallergi',
          description: 'Opskrifter, tips og støtte til dem med fødevareallergi',
          postCount: 156,
          memberCount: 673,
          color: '#d4183d',
          icon: 'UtensilsCrossed'
        },
        {
          id: 4,
          name: 'Eksem',
          description: 'Rådgivning om eksem, hudpleje og lindring',
          postCount: 98,
          memberCount: 445,
          color: '#4ade80',
          icon: 'Home'
        },
        {
          id: 5,
          name: 'Medicin & Behandling',
          description: 'Diskuter medicin, bivirkninger og behandlingsmetoder',
          postCount: 312,
          memberCount: 1567,
          color: '#7c898b',
          icon: 'Pill'
        },
        {
          id: 6,
          name: 'Børn & Familier',
          description: 'Særlig støtte til forældre med allergiske børn',
          postCount: 145,
          memberCount: 789,
          color: '#2e3b47',
          icon: 'Users'
        }
      ];
    }
  },

  getPosts: async (categoryId = null) => {
    try {
      if (isDev) {
        console.info('communityService: running in dev mode — returning mock posts');
        return [
          {
            id: 1,
            author: 'Marie K.',
            time: '2 timer siden',
            title: 'Hvad er jeres erfaringer med luftrensere?',
            content: 'Nogen der har erfaring med luftrensere? Overvejer at købe en til soveværelset. Hvilke mærker anbefaler I?',
            commentCount: 12,
            likes: 8,
            views: 145,
            isPinned: false,
            isLiked: false,
            tags: ['luftrenser', 'allergi']
          },
          {
            id: 2,
            author: 'Lars P.',
            time: '4 timer siden',
            title: 'Pollentallet er højt i dag - tips til lindring',
            content: 'Pollentallet er virkelig højt i dag! Hvad gør I for at lindre symptomerne? Husk at tage jeres medicin tidligt.',
            commentCount: 5,
            likes: 15,
            views: 289,
            isPinned: true,
            isLiked: false,
            tags: ['pollen', 'symptomer']
          },
          {
            id: 3,
            author: 'Anna S.',
            time: '1 dag siden',
            title: 'Ny allergivaccination - mine erfaringer',
            content: 'Jeg har nu fået 3 måneder allergivaccination og kan mærke en stor forskel. Vil gerne dele mine erfaringer.',
            commentCount: 23,
            likes: 34,
            views: 567,
            isPinned: false,
            isLiked: true,
            tags: ['vaccination', 'behandling']
          },
          {
            id: 4,
            author: 'Thomas H.',
            time: '2 dage siden',
            title: 'Hjælp til børn med astma i skolen',
            content: 'Min søn har astma og skal starte i skole. Hvordan håndterer I jeres børns astma i skoletiden?',
            commentCount: 18,
            likes: 12,
            views: 234,
            isPinned: false,
            isLiked: false,
            tags: ['børn', 'skole', 'astma']
          }
        ];
      }
      const endpoint = categoryId
        ? `/api/community/posts?category=${categoryId}`
        : '/api/community/posts';
      return await api.get(endpoint);
    } catch (error) {
      console.error('Error fetching community posts:', error);
      // Fallback mock data
      return [
        {
          id: 1,
          author: 'Marie K.',
          time: '2 timer siden',
          title: 'Hvad er jeres erfaringer med luftrensere?',
          content: 'Nogen der har erfaring med luftrensere? Overvejer at købe en til soveværelset. Hvilke mærker anbefaler I?',
          commentCount: 12,
          likes: 8,
          views: 145,
          isPinned: false,
          isLiked: false,
          tags: ['luftrenser', 'allergi']
        },
        {
          id: 2,
          author: 'Lars P.',
          time: '4 timer siden',
          title: 'Pollentallet er højt i dag - tips til lindring',
          content: 'Pollentallet er virkelig højt i dag! Hvad gør I for at lindre symptomerne? Husk at tage jeres medicin tidligt.',
          commentCount: 5,
          likes: 15,
          views: 289,
          isPinned: true,
          isLiked: false,
          tags: ['pollen', 'symptomer']
        },
        {
          id: 3,
          author: 'Anna S.',
          time: '1 dag siden',
          title: 'Ny allergivaccination - mine erfaringer',
          content: 'Jeg har nu fået 3 måneder allergivaccination og kan mærke en stor forskel. Vil gerne dele mine erfaringer.',
          commentCount: 23,
          likes: 34,
          views: 567,
          isPinned: false,
          isLiked: true,
          tags: ['vaccination', 'behandling']
        },
        {
          id: 4,
          author: 'Thomas H.',
          time: '2 dage siden',
          title: 'Hjælp til børn med astma i skolen',
          content: 'Min søn har astma og skal starte i skole. Hvordan håndterer I jeres børns astma i skoletiden?',
          commentCount: 18,
          likes: 12,
          views: 234,
          isPinned: false,
          isLiked: false,
          tags: ['børn', 'skole', 'astma']
        }
      ];
    }
  },

  getPost: async (postId) => {
    try {
      return await api.get(`/api/community/posts/${postId}`);
    } catch (error) {
      console.error('Error fetching post:', error);
      return null;
    }
  },

  createPost: async (postData) => {
    return await api.post('/api/community/posts', postData);
  },

  getComments: async (postId) => {
    try {
      return await api.get(`/api/community/posts/${postId}/comments`);
    } catch (error) {
      console.error('Error fetching comments:', error);
      // Fallback mock data
      return [
        {
          id: 1,
          author: 'Søren M.',
          time: '1 time siden',
          content: 'Jeg bruger en HEPA luftrenser fra Philips og er meget tilfreds. Den har virkelig hjulpet med mine allergisymptomer.',
          likes: 5
        },
        {
          id: 2,
          author: 'Lise T.',
          time: '3 timer siden',
          content: 'Jeg har prøvet flere mærker, og min anbefaling er klart Blueair. Lidt dyr, men pengene værd!',
          likes: 3
        },
        {
          id: 3,
          author: 'Peter A.',
          time: '5 timer siden',
          content: 'Husk også at se på kvadratmeterkapaciteten. Det er vigtigt at den passer til dit rum.',
          likes: 7
        }
      ];
    }
  },

  addComment: async (postId, commentData) => {
    return await api.post(`/community/posts/${postId}/comments`, commentData);
  },

  likePost: async (postId) => {
    return await api.post(`/community/posts/${postId}/like`, {});
  },

  unlikePost: async (postId) => {
    return await api.delete(`/community/posts/${postId}/like`);
  },

  deletePost: async (postId) => {
    return await api.delete(`/community/posts/${postId}`);
  },

  updatePost: async (postId, updateData) => {
    return await api.patch(`/community/posts/${postId}`, updateData);
  },

  pinPost: async (postId) => {
    return await api.post(`/community/posts/${postId}/pin`, {});
  },

  unpinPost: async (postId) => {
    return await api.delete(`/community/posts/${postId}/pin`);
  }
};